export interface AnnualReviewResponse {
  id: number;
  guid: string;
  userId: string;
  reviewCycleId: string;
  status: 'NOT_STARTED' | string; // Add other possible status values
  clientUtilization: number;
  parPointScore: number;
  expectedParPointScore: number;
  mentorId: string;
  submissionDate: string | null;
  user: User;
  reviewCycle: ReviewCycle;
  reviewCategoryItems: ReviewCategoryItem[];
  reviewScoreItem: ReviewScoreItem;
  promotionRecommendation: boolean | null;
}

export interface AnnualReviewRequest {
  id: number;
  guid: string;
  userId: string;
  reviewCycleId: string;
  status: string;
  frameworkValue: number | null;
  parPointScore: number | null;
  mentorId: string;
  submissionDate: string | null;
  clientUtilization: number;
  user: User;
  reviewCycle: ReviewCycle;
  reviewCategoryItems: ReviewCategoryItem[];
  reviewScoreItem: ReviewScoreItem;
  promotionRecommendation: boolean | null;
}

interface User {
  id: string;
  email: string;
  name: string;
  mentorEmail: string;
  tier: number;
  designation: string;
  isActive: boolean;
  userRoles: unknown;
  lastAccessedDate: string;
  disciplineId: number;
  discipline: Discipline;
  mentor: unknown;
  objectiveCount: number;
}

interface Discipline {
  id: number;
  name: string;
  skillExpectations: unknown;
}

interface ReviewCycle {
  id: string;
  name: string;
  year: number;
  startDate: string;
  endDate: string;
  menteeDeadline: string;
  mentorDeadline: string;
  status: number;
  userClientUtilizations: number;
}

export interface ReviewCategoryItem {
  id: number;
  guid: string;
  userReviewId: number;
  categoryId: number;
  comment: string | null;
  categoryScore: number | null;
  category: Category;
  reviewStatementItems: ReviewStatementItem[];
}

interface Category {
  id: number;
  name: string;
  type: questionCategory;
}

export enum questionCategory {
  Organizational = 'Organizational',
  ProjectLevel = 'Project Level',
  ValueAssignment = 'Value Assignment',
}

export enum questionCategoryName {
  OrganizationalLevelObjectives = 'Organizational-level Objectives',
  SkillAlignment = 'Skill alignment',
  ValueAssignment = 'Value Assignment',
  RolesAndResponsibilities = 'Roles & Responsibilities',
}

export interface ReviewStatementItem {
  id: number;
  guid: string;
  reviewCategoryItemId: number;
  statementId: number;
  score: number | null;
  statement: Statement;
}

interface Statement {
  id: number;
  categoryId: number;
  description: string;
}

interface ReviewScoreItem {
  id: number;
  guid: string;
  userReviewId: number;
  totalScore: number | null;
  finalScore: number | null;
}
